/* eslint-disable */
export default {
  logging: 'Protokollierung...',
  logCall: 'Anruf protokollieren',
  editLog: 'Protokoll bearbeiten',
  select: 'Übereinstimmenden Datensatz auswählen',
  OnHold: 'Wird gehalten',
  Ringing: 'Läutet',
  CallConnected: 'Anruf verbunden',
  unknownUser: 'Unbekannter Benutzer',
  unknownNumber: 'Anonym',
  unavailable: 'Nicht verfügbar',
  viewDetails: 'Details anzeigen',
  addEntity: 'Neu erstellen',
  addLog: 'Protokoll',
  text: 'Text',
  call: 'Anruf',
  addContact: 'Kontakt hinzufügen',
  missedCall: 'Verpasste',
  inboundCall: 'Eingehend',
  outboundCall: 'Ausgehend',
  from: 'Von',
  to: 'An',
  hangup: 'Auflegen',
  accept: 'Antworten',
  toVoicemail: 'An Voicemail',
  anonymous: 'Anonym',
  mergeToConference: 'Mit aktivem Anruf zusammenführen',
  hold: 'Halten',
  unhold: 'Wiederaufnehmen',
  transfer: 'Weiterleiten',
  reject: 'Ablehnen',
  switchCall: 'Anruf zu dieser App wechseln',
  callSwitch: 'Anrufwechsel',
  comfirmContext:
    'Sie befinden sich momentan in einem aktiven Anruf mit {displayName}. Möchten Sie den Anruf auf diesem Gerät fortsetzen?',
  comfirmCancelButton: 'Abbrechen',
  comfirmOKButton: 'Wechseln',
  ignore: 'Ignorieren',
  holdAndAnswer: 'Halten und antworten',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
